if (!customElements.get('hero-slideshow')) {
  customElements.define(
    'hero-slideshow',
    class HeroSlideshow extends HTMLElement {
      constructor() {
        super();
        this.index = 0;
        this.timer = null;
      }

      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.hero-slide'));
        this.dots = Array.from(this.querySelectorAll('.hero-slideshow__dot'));
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
        this.autoplay = this.dataset.autoplay === 'true';
        this.interval = (parseInt(this.dataset.speed, 10) || 5) * 1000;
        this.count = this.slides.length;

        if (this.count <= 1) return;

        this.prevBtn && this.prevBtn.addEventListener('click', () => this.go(this.index - 1, true));
        this.nextBtn && this.nextBtn.addEventListener('click', () => this.go(this.index + 1, true));
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i, true)));

        // Swipe táctil
        let startX = 0;
        this.addEventListener(
          'touchstart',
          (e) => {
            startX = e.touches[0].clientX;
          },
          { passive: true }
        );
        this.addEventListener(
          'touchend',
          (e) => {
            const dx = e.changedTouches[0].clientX - startX;
            if (Math.abs(dx) > 40) this.go(this.index + (dx < 0 ? 1 : -1), true);
          },
          { passive: true }
        );

        // Pausar al pasar el mouse
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());

        // Soporte del editor de temas
        if (window.Shopify && window.Shopify.designMode) {
          this.addEventListener('shopify:block:select', (e) => {
            const slide = e.target.closest('.hero-slide');
            const i = this.slides.indexOf(slide);
            if (i >= 0) {
              this.go(i, false);
              this.stop();
            }
          });
          this.addEventListener('shopify:block:deselect', () => this.start());
        }

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.autoplay && !reduceMotion) this.start();
      }

      go(i, userTriggered) {
        this.index = (i + this.count) % this.count;
        this.slides.forEach((slide, idx) => {
          const active = idx === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        this.dots.forEach((dot, idx) => {
          const active = idx === this.index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
        if (userTriggered) this.restart();
      }

      start() {
        if (!this.autoplay || this.count <= 1) return;
        this.stop();
        this.timer = setInterval(() => this.go(this.index + 1, false), this.interval);
      }

      stop() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }

      restart() {
        this.stop();
        this.start();
      }

      disconnectedCallback() {
        this.stop();
      }
    }
  );
}
